import * as types from './actionTypes';

export const setContacts = (contacts) => ({
  type: types.SET_CONTACTS,
  contacts,
});

export const addContact = (contact) => ({
  type: types.ADD_CONTACT,
  contact,
});

export const updateContact = (contact) => ({
  type: types.UPDATE_CONTACT,
  contact,
});

export const deleteContact = (uuid) => ({
  type: types.DELETE_CONTACT,
  uuid,
});

export const setNotes = (notes) => ({
  type: types.SET_NOTES,
  notes,
});

export const addNote = (note) => ({
  type: types.ADD_NOTE,
  note,
});

export const updateNote = (note) => ({
  type: types.UPDATE_NOTE,
  note,
});

export const deleteNote = (uuid) => ({
  type: types.DELETE_NOTE,
  uuid,
});

export const setAttachedFiles = (files) => ({
  type: types.SET_ATTACHED_FILES,
  files,
});

export const deleteAttachedFile = (filename) => ({
  type: types.DELETE_ATTACHED_FILE,
  filename,
});

export const setWeather = (weather) => ({
  type: types.SET_WEATHER,
  weather,
});

export const setMeetingLocation = (location) => ({
  type: types.SET_MEETING_LOCATION,
  location,
});

export const setEquipment = (equipment) => ({
  type: types.SET_EQUIPMENT,
  equipment,
});

export const updateEquipment = (equipmentUpdate) => ({
  type: types.UPDATE_EQUIPMENT,
  equipmentUpdate,
});

export const deleteEquipment = (serialNumber) => ({
  type: types.DELETE_EQUIPMENT,
  serialNumber,
});

export const setCrew = (crew) => ({
  type: types.SET_CREW,
  crew,
});

export const updateCrew = (crewUpdate) => ({
  type: types.UPDATE_CREW,
  crewUpdate,
});

export const deleteCrew = (serialNumber) => ({
  type: types.DELETE_CREW,
  serialNumber,
});

export const setPeople = (people) => ({
  type: types.SET_PEOPLE,
  people,
});

export const updatePeople = (peopleUpdate) => ({
  type: types.UPDATE_PEOPLE,
  peopleUpdate,
});

export const deletePeople = (serialNumber) => ({
  type: types.DELETE_PEOPLE,
  serialNumber,
});

export const setLineTypes = (lineTypes) => ({
  type: types.SET_LINE_TYPES,
  lineTypes,
});

export const addLineType = (lineType) => ({
  type: types.ADD_LINE_TYPE,
  lineType,
});

export const updateLineType = (lineType) => ({
  type: types.UPDATE_LINE_TYPE,
  lineType,
});

export const deleteLineType = (lineType) => ({
  type: types.DELETE_LINE_TYPE,
  lineType,
});

export const setActivityLog = (activityLog) => ({
  type: types.SET_ACTIVITY_LOG,
  activityLog,
});

export const setCurrentJobID = (jobID) => ({
  type: types.SET_CURRENT_JOB_ID,
  jobID,
});

export const resetJobDashboard = () => ({
  type: types.RESET_JOB_DASHBOARD,
});
